module.exports = __webpack_public_path__ + "img/play.4cad6697.svg";